type KeyString = {
  [key: string]: string
}

export const FREQUENCIE_INTERVAL_OBJECT: KeyString = {
  DAYLE: 'Diário',
  WEEKLY: 'Semanal',
  BIWEEKLY: 'Quinzenal',
  MONTHLY: 'Mensal',
  BIMONTHLY: 'Bimestral',
  TRIMONTHLY: 'Trimestal',
  SEMESTERLY: 'Simestral',
  YEARLY: 'Anual',
}
